import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, Ref } from 'vue';

import {
  NavBar,
  Heading,
  Row,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { PasswordModal } from '../PasswordModal';
import { EMarginAllocationSteps } from '@/modules/trade/views/MarginAllocation/helpers';

interface IDataForm {
  balance: { value: number; formatted: string };
  drawdown: { value: number; formatted: string };
  isUpdatingLimits: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Review',
  setup(__props) {

const changeStep = inject('changeStep', (step: EMarginAllocationSteps) => ({
  step
}));
const fetchUpdateLimits = inject('fetchUpdateLimits', () => ({}));
const dataForm = inject('dataForm') as Ref<IDataForm>;

const isPasswordModalOpen = ref(false);

const details = computed(() => {
  return [
    {
      title: 'Saldo alocado',
      subtitle: `R$ ${dataForm.value.balance.formatted}`,
      step: EMarginAllocationSteps.BALANCE
    },
    {
      title: 'Prejuízo máximo',
      subtitle: `R$ ${dataForm.value.drawdown.formatted}`,
      step: EMarginAllocationSteps.DRAWDOWN
    }
  ];
});

function confirmPassword() {
  isPasswordModalOpen.value = false;

  fetchUpdateLimits();
}

function handleBack() {
  changeStep(EMarginAllocationSteps.DRAWDOWN);
}

return { __sfc: true,changeStep, fetchUpdateLimits, dataForm, isPasswordModalOpen, details, confirmPassword, handleBack, NavBar, Heading, Row, ButtonContainer, ButtonPrimary, BackButton, PasswordModal }
}

})